import {
  isObjectWithProperty,
  isNotANumber,
  filterKeys,
  promoteKey,
  isAValue,
} from "web/services/helpers"

import { calculateShown, getValueForFields } from "web/services/field"

export function isInputableField(field) {
  return (
    !(field.is_attribute && !field.is_editable_attribute) && !field.expression
  )
}

export function fieldIsVisible(field, value) {
  if (field.is_attribute && !field.is_editable_attribute) return false
  return calculateShown(field, value) === true // Handles Possible String Error From evaluation context
}

export function getFormValue(value, fields) {
  return promoteKey(
    filterKeys(
      value,
      fields.map((f) => f.key)
    ),
    "form_value"
  )
}

export const getGlobalValue = getValueForFields

export function getSectionsToShow({ sections, fields }) {
  const fieldInList = (field) => fields.find((el) => el.id === field.id)

  return sections
    .map((section) => ({
      id: section.id,
      label: section.label,
      fields: section.fields
        .map(fieldInList)
        .filter((field) => field !== undefined),
    }))
    .filter((section) => section.fields.length !== 0)
}

export function getSectionsToShowWithOtherToggle({ sections, fields }) {
  const allSections = getSectionsToShow({ sections, fields })

  const otherSectionIndex = allSections.findIndex(
    (s) => s.label === "Other Fields"
  )

  const hasOtherSection = otherSectionIndex !== -1
  const showOtherFieldsToggle = hasOtherSection && allSections.length > 1

  const otherSection =
    showOtherFieldsToggle && allSections.splice(otherSectionIndex, 1)[0]

  return {
    configuredSections: allSections,
    otherSection,
    showOtherFieldsToggle,
  }
}

export function fieldDoesNotBlur(field) {
  return (
    [
      "Boolean",
      "Company",
      "Date",
      "Lookup",
      "Portfolio",
      "User",
      "RichText",
      "Contact",
      "InternalContact",
    ].includes(field.kind) ||
    (field.kind === "Text" && field.multiple_values)
  )
}

export function sigDigits(val, offset) {
  const valStr = val.toString()

  return Math.max(
    (valStr.includes(".") ? valStr.split(".")[1].length : 0) + offset,
    0
  )
}

export function textValuesAreActuallyDifferent(a, b) {
  if (isNotANumber(a) || isNotANumber(b)) {
    // eslint-disable-next-line eqeqeq
    return a != b
  } else {
    // eslint-disable-next-line eqeqeq
    return Number.parseFloat(a) != Number.parseFloat(b)
  }
}

export function formValuesAreDifferent(a, b) {
  if (isMultiValue(a) !== isMultiValue(b)) {
    return true
  }

  if (isMultiValue(a)) {
    return anyDataValuesDiffer(a, b)
  } else {
    return dataValueDiffers(a, b)
  }
}

function isMultiValue(input) {
  return Array.isArray(input)
}

function anyDataValuesDiffer(a, b) {
  if (a.length !== b.length) {
    return true
  }

  for (const dataValue of a) {
    const match = b.find((candidate) => !dataValueDiffers(dataValue, candidate))

    if (match === undefined) {
      return true
    }
  }

  return false
}

function dataValueDiffers(a, b) {
  const noValueForA = !(isObjectWithProperty(a, "value") && isAValue(a.value))
  const noValueForB = !(isObjectWithProperty(b, "value") && isAValue(b.value))

  const noUnitForA = !(isObjectWithProperty(a, "unit") && isAValue(a.unit))
  const noUnitForB = !(isObjectWithProperty(b, "unit") && isAValue(b.unit))

  const aIsBlank = noValueForA && noUnitForA
  const bIsBlank = noValueForB && noUnitForB

  if (aIsBlank !== bIsBlank) return true
  if (aIsBlank && bIsBlank) return false

  return a.value !== b.value || a.unit !== b.unit
}

export function getValidInputValue(value) {
  if (isObjectWithProperty(value, "value")) {
    const innerValue = value.value
    if (typeof innerValue === "string") return innerValue
    if (typeof innerValue === "number") return innerValue.toString()
  }

  return ""
}
